import { Col, Form, Input, Row } from "antd";

import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BalanceContext from "../../context/BalanceContext";
import { ButtonProps } from "../../helpers/constants";
import { removeSpacesFromString } from "../../helpers/strings";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaSelect from "../Items/Select/Index";
import ConfirmInternetConnectionCreationModal from "../Modals/ConfirmInternetConnectionCreationModal";
import PlusIcon from "./../../assets/svgs/IconsWhite/PlusIcon.svg";

const CreateInternetForm = () => {
  const { value, setValue } = useContext(BalanceContext);

  const navigate = useNavigate();

  const { openNotification, contextHolder } = useMultiNotification();
  const { intPkHeadID } = useParams();
  const [form] = Form.useForm();
  const [
    getAreasApi,
    areasApiResponse,
    areasApiError,
    areasApiLoading,
    areasApiMessage,
    areasApiErrorCount,
  ] = useAxiosPost<ResponseProp>("areas/getAreasByOwner");
  const [
    getSubAreasApi,
    subAreasApiResponse,
    subAreasApiError,
    subAreasApiLoading,
    subAreasApiMessage,
    subAreasApiErrorCount,
  ] = useAxiosPost<SubAreasByAreaIDApiProp>("areas/getSubAreasByAreaID");

  const [
    getIspsApi,
    ispsApiResponse,
    ispsApiError,
    ispsApiLoading,
    ispsApiMessage,
    ispsApiErrorCount,
  ] = useAxiosPost<ResponseProp>("isps/getISPsByCompanyWithPublicIsps");
  const [
    postSimpleConnectionWithISPApi,
    simpleConnectionWithISPApiResponse,
    simpleConnectionWithISPApiError,
    simpleConnectionWithISPApiLoading,
    simpleConnectionWithISPApiMessage,
    simpleConnectionWithISPApiErrorCount,
  ] = useAxiosPost<any>(
    "connections/createSimpleInternetConnectionWithISP",
    true
  );
  const [show, setShow] = useState<boolean>(false);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState<null | string>(null);
  const [selectedISP, setSelectedISP] = useState<null | string>(null);
  const [areas, setAreas] = useState<NetwalaSelectOptions[]>([]);
  const [subAreas, setSubAreas] = useState<NetwalaSelectOptions[]>([]);
  const [isps, setIsps] = useState<NetwalaSelectOptions[]>([]);
  const [confirmationData, setConfirmationData] =
    useState<ConfirmInternetConnection | null>(null);
  const [dataToSend, setDataToSend] = useState<any>(null);

  useEffect(() => {
    getAreasApi({});
    getIspsApi({});
  }, []);
  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setAreas(areas);
    }
  }, [areasApiResponse]);
  useEffect(() => {
    if (subAreasApiResponse !== null) {
      const data: any = subAreasApiResponse.responseData;
      const subAreas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setSubAreas(subAreas);
    }
  }, [subAreasApiResponse]);
  useEffect(() => {
    if (ispsApiResponse !== null) {
      const data: any = ispsApiResponse.responseData;
      const isps = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkIspID,
          label: item.ISPName,
        };
      });

      setIsps(isps);
    }
  }, [ispsApiResponse]);

  useEffect(() => {
    if (simpleConnectionWithISPApiResponse !== null) {
      const { message } = simpleConnectionWithISPApiResponse;
      if (message) {
        setValue(value + 1);
        openNotification(`success`, "Success", message);
        setTimeout(() => {
          navigate(-1);
        }, 2500);
      }
    }
  }, [simpleConnectionWithISPApiResponse]);

  useEffect(() => {
    if (
      simpleConnectionWithISPApiError !== null &&
      simpleConnectionWithISPApiErrorCount !== 0
    ) {
      openNotification(
        `error`,
        "Operation Failed",
        simpleConnectionWithISPApiError
      );
    }
  }, [simpleConnectionWithISPApiError, simpleConnectionWithISPApiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {};
  const handleAreaChange = (value: string) => {
    setSelectedSubArea(null);
    form.setFieldsValue({ subArea: undefined });

    getSubAreasApi({ intPkAreaID: Number(value) });
  };
  const onFinish = (values: any) => {
    const area = areas.find(
      (item) => Number(item.value) === Number(values.area)
    );
    const subArea = subAreas.find(
      (item) => Number(item.value) === Number(values.subArea)
    );

    if (!area) {
      openNotification("error", "Validation Error", "Please select an area");
      return;
    }

    if (!values.isp) {
      openNotification("error", "Validation Error", "Please select an ISP");
      return;
    }

    const selectedISPData = isps.find(
      (item) => Number(item.value) === Number(values.isp)
    );

    const _confirmationData: ConfirmInternetConnection = {
      ispUrl: "",
      packageName: "",
      packagePrice: "0",
      area: area.label,
      subArea: subArea?.label || "",
      username: removeSpacesFromString(values.username?.trim()),
      password: values.password,
      vlan: "",
      address: values.address,
      voucherNumber: "",
      ontID: null,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      ispName: selectedISPData?.label || "",
    };
    setConfirmationData(_confirmationData);
    setShow(true);

    // Data for connection creation with ISP (required)
    const dataToSendValue: any = {
      areaId: values.subArea ? Number(values.subArea) : Number(values.area),
      address: values.address,
      email: values.email || "",
      username: removeSpacesFromString(values.username?.trim()),
      password: values.password,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      nicNumber: values.nicNumber || null,
      intPkIspID: Number(values.isp),
    };

    setDataToSend(dataToSendValue);
  };
  const validateConfirmPassword = (_: any, value: string) => {
    const { password } = form.getFieldsValue();
    console.log({ password });
    if (value && value !== password) {
      return Promise.reject(
        new Error("The two passwords that you entered do not match!")
      );
    }
    return Promise.resolve();
  };
  const handleClose = (isConfirm: boolean) => {
    setShow(false);
    if (isConfirm === true && dataToSend !== null) {
      postSimpleConnectionWithISPApi(dataToSend);
    }
  };

  return (
    <>
      {show === true && confirmationData !== null && (
        <ConfirmInternetConnectionCreationModal
          show={show}
          handleClose={handleClose}
          confirmationData={confirmationData}
        />
      )}
      {contextHolder}

      <Row style={{ width: "100%" }}>
        <Form
          name="createInternetConnectionForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          requiredMark={false}
          style={{ width: "100%" }}
          form={form}
        >
          {/* First */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">First Name</span>
                }
                name="firstName"
                getValueFromEvent={(e) => e.target.value.trimStart()} // trims start spaces as user types
                rules={[
                  {
                    required: true,
                    message: "Please enter First Name",
                  },
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: "Only letters, numbers, and spaces are allowed",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject("Name cannot be just spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="John"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // trim on blur
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Last Name</span>
                }
                name="lastName"
                getValueFromEvent={(e) => e.target.value.trimStart()}
                rules={[
                  {
                    required: true,
                    message: "Please enter Last Name",
                  },
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: "Only letters, numbers, and spaces are allowed",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject("Name cannot be just spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Doe"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Second */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Phone Number</span>
                }
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter Phone number",
                  },
                  {
                    pattern: /^(?:\+92|0)?3[0-9]{9}$/,
                    message: "Please enter a valid Pakistani phone number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03001235467"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Email</span>}
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="user@example.com"
                />
              </Form.Item>
            </Col>
          </Row>
          {/* NIC Number Row */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">NIC Number</span>
                }
                name="nicNumber"
              >
                <Input
                  className="user-input-general-height"
                  placeholder="12345-1234567-1"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">ISP</span>}
                name="isp"
                rules={[
                  {
                    required: true,
                    message: "Please select ISP",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedISP}
                  onChange={(value) => setSelectedISP(value)}
                  size="large"
                  height="45px"
                  options={isps}
                  placeHolder="Select ISP"
                />
              </Form.Item>
            </Col>
          </Row>
          {/* Address Row */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label={<span className="create-user-form-label">Address</span>}
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Address",
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (value.includes("'")) {
                          return Promise.reject(
                            "Address cannot contain single quote (') character"
                          );
                        }
                        if (value.includes("--")) {
                          return Promise.reject(
                            "Address cannot contain (--) pattern "
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="House No."
                />
              </Form.Item>
            </Col>
          </Row>
          {/* Third */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Area</span>}
                name="area"
                rules={[
                  {
                    required: true,
                    message: "Please Select Area",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedArea}
                  onChange={handleAreaChange}
                  size="large"
                  height="45px"
                  options={areas}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Sub Area</span>}
                name="subArea"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Sub Area",
                //   },
                // ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedSubArea}
                  size="large"
                  height="45px"
                  options={subAreas}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Fourth - Username and Password */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Username</span>}
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please enter Username",
                  },
                  {
                    pattern: /^[a-zA-Z0-9@._-]+$/,
                    message:
                      "Username can only contain letters, numbers, @, period (.), underscore (_), and hyphen (-)",
                  },
                  {
                    whitespace: true,
                    message: "Username cannot be empty or contain only spaces",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="johnDeo121"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Password</span>}
                name="password"
                getValueFromEvent={(e) => e.target.value.trimStart()} // prevent leading spaces
                rules={[
                  {
                    required: true,
                    message: "Please enter Password",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject(
                          "Password cannot be empty or contain only spaces"
                        );
                      }
                      if (/\s/.test(value)) {
                        return Promise.reject("Password cannot contain spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Password"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // remove trailing spaces when done typing
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* Fifth - Confirm Password */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">
                    Confirm Password
                  </span>
                }
                dependencies={["password"]}
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please enter Password",
                  },
                  {
                    validator: validateConfirmPassword,
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Password"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "center" }}
              span={24}
            >
              <Form.Item>
                <NetwalaButton
                  htmlType="submit"
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={"50px"}
                  width={"372px"}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {
                    console.log("clicked");
                  }}
                  text="Create Internet Connection"
                  icon={<img src={PlusIcon} />}
                  disabled={simpleConnectionWithISPApiLoading}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};
export default CreateInternetForm;
